/* eslint-disable jsx-a11y/anchor-has-content */
import React from 'react';
import './SingleProduct.css';
import GppGoodRoundedIcon from '@mui/icons-material/GppGoodRounded';
import AddtoCart from './AddtoCart';
import IncreaseAndDecrease from './IncreaseAndDecrease';
import SnackbarComponent from '../SnackbarComponent/SnackbarComponent';
import ImageMagnifiyer from './ImageMagnifiyer';
import { useSelector, useDispatch } from 'react-redux'
import { getInitialCounter } from '../../features/cart/cartSlice';
import { useEffect } from 'react';
const SingleProduct = ({ open, currentProduct, addToCart, id, click, setSnackPack }) => {

    const { counter } = useSelector(state => state.cart)
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getInitialCounter(currentProduct?.uniqueId))
    }, [currentProduct?.uniqueId, dispatch]);
    
    // ৳

    return (
        <>
            <SnackbarComponent open={open} />

            <div className="container overview single-product-block">
                {
                    <div className="row">
                        <ImageMagnifiyer currentProduct={currentProduct} />
                        <div className="col-md-7">
                            <div className="card" >
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col">
                                            <h3 className='rev-title'>
                                                {currentProduct?.name}
                                            </h3>
                                            <p className='pd-weight'>{currentProduct?.quantity}</p>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col">
                                            <h2 className='rev-pd-price'>৳{counter * parseInt(currentProduct?.price)}</h2>
                                        </div>
                                    </div>

                                    <IncreaseAndDecrease counter={counter} />

                                    <AddtoCart addToCart={addToCart} id={id} counter={counter} click={click} setSnackPack={setSnackPack} />

                                    <div className="row">
                                        <div className="col">
                                            <p className='safe-secure'>
                                                <GppGoodRoundedIcon /> Safe and Secure payments.100% Authentic products
                                            </p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <h3 className='specifications'>
                                                Specifications
                                            </h3>
                                        </div>
                                    </div>

                                    <div className="row">
                                        {
                                            [
                                                { hints: 'Brand', title: 'Hppilo' },
                                                { hints: 'Style', title: 'Snack Nuts' },
                                                { hints: 'Country of Origin', title: 'Turkey' },
                                                { hints: 'Expiry in Days', title: '133' },
                                                { hints: 'Manufacturer Details', title: 'Happilo International Pvt Ltd, 7, 1st floor, yeshwantpur, Bangalore 560022.' },
                                            ].map((item, index) => (
                                                <React.Fragment key={index}>
                                                    <div className="col-4 col-sm-3">
                                                        <h6 className='hints'>{item.hints}</h6>
                                                    </div>
                                                    <div className="col-8 col-sm-9">
                                                        <h6 className='title' >{item.title}</h6>
                                                    </div>
                                                </React.Fragment>
                                            ))
                                        }
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        </>
    );
};

export default SingleProduct;